const CANCELLATION_BLOCKED_POT_STATUSES = new Set([
  "Submitting",
  "Submitted",
  "Rejected",
  "Approved",
  "Paid",
]);

const CANCELLABLE_ALLOCATION_STATUSES = new Set([
  "InProgress",
  "Pending",
  "Booked",
  "Approved",
  "Rejected",
]);

interface AdminCancellationState {
  allocationStatus: string | undefined;
  hasPotSubmission: boolean;
  potStatus?: string;
}

export function canAdminCancelAllocation({
  allocationStatus,
  hasPotSubmission,
  potStatus,
}: AdminCancellationState): boolean {
  if (
    !allocationStatus ||
    !CANCELLABLE_ALLOCATION_STATUSES.has(allocationStatus)
  ) {
    return false;
  }

  if (potStatus !== undefined) {
    return !CANCELLATION_BLOCKED_POT_STATUSES.has(potStatus);
  }

  return !hasPotSubmission;
}
